import { Field, NumericInput, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent, WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import React from 'react';

let DryingAtLaterSeparationSection: React.FC<IWorksheetComponent> = () => {
  return (
    <>
      <ListFieldSection heading="Coarse Portion Mass">
        <Field input={<TextOutput />} name="Masses.WetMass" label="Specimen Total Mass" />
        <Field input={<TextOutput />} name="Separation.CoarsePortion.Masses.DryMass" />
        <Field input={<TextOutput />} name="Separation.FinePortion.Masses.WetMass" />
        <Field input={<TextOutput />} name="Separation.FinePortion.Masses.DryMass" />
      </ListFieldSection>

      <ListFieldSection heading="Fine Portion Subspecimen Mass">
        <NamePrefixModifier appendNamePrefix="Separation.FinePortion.Subspecimen.Masses">
          <WorksheetBalanceFieldSet
            name="MassMeasurement.Equipment.Balance"
            copyTo={['MassMeasurement.Equipment.DryMassBalance']}
          />
          <Field input={<NumericInput />} name="MassMeasurement.TareMass" />
          <Field input={<NumericInput />} name="MassMeasurement.TareAndWetMass" label="Tare and Subspecimen Mass" />
          <Field input={<TextOutput />} name="WetMass" label="Subspecimen Mass" />
        </NamePrefixModifier>
      </ListFieldSection>
    </>
  );
};

DryingAtLaterSeparationSection = withInjectedProps(DryingAtLaterSeparationSection);

export { DryingAtLaterSeparationSection };
export default DryingAtLaterSeparationSection;
